/*
 * argile-finitions.js — « Toutes nos finitions ».
 * Construit la navigation sticky « Gamme de finitions » à partir des gammes rendues
 * (`[data-finitions-gamme]` → id + `data-nav-label`), gère le clic (smooth scroll,
 * l'offset header vient du `scroll-margin-top` CSS) et le scroll-spy (lien actif via
 * IntersectionObserver). Re-câblé à `shopify:section:load` (éditeur).
 */
(function () {
  'use strict';

  function initFinitions(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll('[data-argile-finitions]');
    if (!groups.length) return;

    groups.forEach(function (group) {
      if (group.dataset.argileWired) return;
      group.dataset.argileWired = '1';

      var list = group.querySelector('[data-finitions-nav-list]');
      var gammes = [].slice.call(group.querySelectorAll('[data-finitions-gamme]'));
      if (!list || !gammes.length) return;

      // Construire les liens depuis les gammes (qui ont un id + un libellé).
      list.innerHTML = '';
      var links = [];
      gammes.forEach(function (gamme, i) {
        if (!gamme.id) gamme.id = 'finitions-gamme-' + (i + 1);
        var label = gamme.getAttribute('data-nav-label') || gamme.id;

        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'argile-finitions__nav-link';
        a.href = '#' + gamme.id;
        a.textContent = label;
        a.addEventListener('click', function (event) {
          event.preventDefault();
          gamme.scrollIntoView({ behavior: 'smooth', block: 'start' });
          setActive(i);
        });
        li.appendChild(a);
        list.appendChild(li);
        links.push(a);
      });

      function setActive(index) {
        links.forEach(function (a, i) {
          a.classList.toggle('is-active', i === index);
        });
      }
      setActive(0);

      // Scroll-spy : la gamme dont le haut franchit la zone supérieure devient active.
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var idx = gammes.indexOf(entry.target);
              if (idx >= 0) setActive(idx);
            });
          },
          { rootMargin: '-25% 0px -70% 0px', threshold: 0 }
        );
        gammes.forEach(function (gamme) { observer.observe(gamme); });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initFinitions(document); });
  } else {
    initFinitions(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFinitions(event.target);
  });
})();
